import { useThree, type RootState } from "@react-three/fiber";
import { useEffect } from "react";

declare global {
  interface Window {
    // Expected naming scheme by @regnaroek/playwright-three
    // eslint-disable-next-line @typescript-eslint/naming-convention
    PLAYWRIGHT_THREE?: RootState;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    EXPOSE_THREE?: boolean;
  }
}

/** @returns Exposes the ThreeJs scene state to the E2E testing library. */
export function ExposeThree(): null {
  const state = useThree();

  useEffect(() => {
    // Only expose the state when running the playwright test
    // The flag is set in an init script
    if (!globalThis.window.EXPOSE_THREE) return;

    globalThis.window.PLAYWRIGHT_THREE = state;
  }, [state]);

  return null;
}
